import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import TablaMRT from "../../features/table/RTable";
import CustomButton from "../../ui/button/Button";
import SideMenu from "../../features/sideMenu/SideMenu";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import {
  abrirReporte,
  fetchTrabajosConAsignados,
  generarExcelAsignacionTrabajos,
  generarZipReportesTrabajos,
  descargarExcelTrabajos,
  descargarExcelTrabajosYParametros,
  descargarPDFTrabajos,
} from "../functions/Projects";
import {
  itemsProjects,
  statusOptions,
  defaultCriterios,
} from "../../constants/projects";
import { useNavigate } from "react-router-dom";
import Buscar from "../../assets/img/svg/buscar.svg";
import ProjectFilterModal from "../../features/projectFilterModal/ProjectFilterModal";
import { ImagenesModal } from "../../features/imagenesModal/ImagenesModal";
import { ParametrosModal } from "../../features/parametrosModal/ParametrosModal";
import Card from "../../features/cards/CardsGraph";
import { highlightText, formatEmpresa } from "../../utils/functionsFormat";
import {
  headCellLeftAlign,
  headCellCenterAlign,
  bodyCellCenterAlign,
} from "../../utils/columnStyles";
import {
  customNumberFilter,
  customStringFilter,
  customStrainFilter,
} from "../../features/table/filterFunctions";
import {
  ClickAwayListener,
  Box,
  Popper,
  Button,
  IconButton,
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
} from "@mui/material";
import "./ProjectsPage.responsive.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import TrackerProjectsStepper from "../../features/stepper/TrackerProjectStepper";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  getTrackerProyectos,
  getTrackerProyectosEvents,
} from "../functions/Notifications";
import TrackerStepperProjects from "../../features/stepper/TrackerStepperProjects";
import LoaderDialog from "../../ui/loader/Loader";
import ModalNuevaAsignacion from "../../features/asignacionTrabajoModal/ModalNuevaAsignacion";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DescargarG from "../../assets/img/svg/users/descargarGreen.svg";
import DescargarG2 from "../../assets/img/svg/users/descargar.svg";
import TablaAsignaciones from "./TablaAsignaciones";
import FilterChips from "./FilterChips";
import Link from "@mui/icons-material/Link";
import ModalExcelAsignaciones from "../../features/asignacionTrabajoModal/ModalExcelAsignaciones";
import SubirG from "../../assets/img/svg/providers/CargarVerde.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ModalSubirExcelTrabajos from "../../features/asignacionTrabajoModal/modalesReportes/ModalSubirExcelTrabajos";
import ModalSubirExcelAsignaciones from "../../features/asignacionTrabajoModal/modalesReportes/ModalSubirExcelAsignaciones";

const txt = (s) => (s ?? "").toString().trim().toUpperCase();

const detectTipos = (items = []) => {
  let hasLev = false,
    hasImp = false,
    hasMant = false;
  for (const a of items) {
    const t = txt(
      a?.categoriaParametro?.descripcion ??
        a?.categoriaParametro?.name ??
        a?.faseTrabajo?.descripcion ??
        a?.faseTrabajo?.name ??
        ""
    );
    if (t.includes("LEVANTAMIENTO")) hasLev = true;
    if (t.includes("ENTREGABLE") || t.includes("IMPLEMENTACIÓN")) hasImp = true;
    if (t.includes("MANTENIMIENTO")) hasMant = true;
  }
  return { hasLev, hasImp, hasMant };
};

const ProjectsPage = ({
  API_URL,
  clients,
  permisionarios,
  projects,
  companies,
  states,
  user,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [data, setData] = useState([]);
  const sortedData = useMemo(() => {
    return [...data].sort((a, b) => {
      const valorA = (a?.cliente?.razonSocial || "").toLowerCase();
      const valorB = (b?.cliente?.razonSocial || "").toLowerCase();
      return valorA.localeCompare(valorB); // DESC
    });
  }, [data]);
  const [openMenuIndex, setOpenMenuIndex] = useState({ top: 0, left: 0 }); // Estado para el menú desplegable
  const [filteredBase, setFilteredBase] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedTrabajo, setSelectedTrabajo] = useState(null);
  const [criterios, setCriterios] = useState(defaultCriterios);
  const [showParametroModal, setShowParametroModal] = useState(false);
  const [timestamp, setTimestamp] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedEtapa, setSelectedEtapa] = useState(null);
  const [tableInstance, setTableInstance] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [events, setEvents] = useState([
    {
      id: 0,
      id_trabajo: 0,
      id_empresa: null,
      etapa: 1,
      estatus: "completado",
      id_usuario: user.id,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    },
    {
      id: 0,
      id_trabajo: 0,
      id_empresa: null,
      etapa: 2,
      estatus: "pendiente",
      id_usuario: user.id,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    },
  ]);
  const [showAsignacionModal, setShowAsignacionModal] = useState(false);

  const [detailMode, setDetailMode] = useState("tracker");

  const [width, setWidth] = useState(window.innerWidth);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [showModalExcel, setShowModalExcel] = useState(false);

  const [showModalSubirArchivo, setShowModalSubirArchivo] = useState(false);

  const [
    showModalSubirArchivoAsignaciones,
    setShowModalSubirArchivoAsignaciones,
  ] = useState(false);

  const [baseCounts, setBaseCounts] = useState({
    total: 0,
    totalWithAssignments: 0,
    byCategory: {
      LEVANTAMIENTO: 0,
      ENTREGABLE: 0,
      MANTENIMIENTO: 0,
    },
  });

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });
  const [rowCount, setRowCount] = useState(0);

  const pageCache = useRef(new Map());

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getSelectedRows = () => {
    const selectedRows = tableInstance
      .getSelectedRowModel()
      .flatRows.map((row) => {
        return row.original;
      });
    return selectedRows;
  };

  const handleConfirmExcel = async (data) => {
    const rows = getSelectedRows();
    rows.forEach((row) => {
      delete row.tracker;
      delete row.trabajosAsignados;
      delete row.etapa;
      row.seleccion = true;
    });
    const payload = {
      ...data,
      trabajos: getSelectedRows(),
    };
    try {
      const res = await generarExcelAsignacionTrabajos(API_URL, payload);
      descargarExcelYReporte("asignaciones-trabajos.xls", res);
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarMessage("Ocurrió un error al generar el excel.");
    } finally {
      setShowModalExcel(false);
    }
  };

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  const toggleRowWithMode = (row, mode) => {
    const expanded = row.getIsExpanded();
    const sameMode = detailMode === mode;

    if (tableInstance) {
      const shouldExpand = expanded ? !sameMode : true;
      if (shouldExpand) {
        tableInstance.setExpanded({ [row.id]: true });
        setDetailMode(mode);
        setSelectedProject(row.original);
      } else {
        tableInstance.resetExpanded();
        setSelectedProject(null);
      }
    }
  };

  const navigate = useNavigate();
  const handleOpenModal = useCallback(() => setShowModal(true), []);
  const handleCloseModal = useCallback(() => setShowModal(false), []);

  useEffect(() => {
    const fetchEvents = async () => {
      if (selectedProject) {
        const events = await getTrackerProyectosEvents(
          API_URL,
          selectedProject.id
        );
        if (events.length > 0) {
          setEvents(events);
        } else {
          setEvents([
            {
              id: 0,
              id_trabajo: selectedProject.id,
              id_empresa: null,
              etapa: 1,
              estatus: "completado",
              id_usuario: user.id,
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
            },
            {
              id: 0,
              id_trabajo: selectedProject.id,
              id_empresa: null,
              etapa: 2,
              estatus: "pendiente",
              id_usuario: user.id,
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
            },
          ]);
        }
      }
    };
    fetchEvents();
  }, [selectedProject]);

  const handleEtapaFilter = (etapa) => {
    if (tableInstance) tableInstance.resetExpanded();
    setSelectedProject(null);
    if (etapa === selectedEtapa) {
      setSelectedEtapa(null);
    } else {
      setSelectedEtapa(etapa);
    }
  };

  useEffect(() => {
    if (!selectedEtapa) {
      setData(filteredBase);
      return;
    }

    setData(
      filteredBase.filter(
        (item) => !selectedEtapa || item.etapa === selectedEtapa
      )
    );
  }, [selectedEtapa, filteredBase]);

  useEffect(() => {
    const fetchBaseCounts = async () => {
      try {
        const response = await fetchTrabajosConAsignados(
          API_URL,
          { ...defaultCriterios, faseTrabajoFilter: null },
          1, // limit 1, we only need counts
          0
        );

        const { total, totalWithAssignments, byCategory } = response;

        setBaseCounts({
          total: total || 0,
          totalWithAssignments: totalWithAssignments || 0,
          byCategory: byCategory || {
            LEVANTAMIENTO: 0,
            ENTREGABLE: 0,
            MANTENIMIENTO: 0,
          },
        });
      } catch (error) {
        console.error("Error fetching base counts:", error);
      }
    };

    fetchBaseCounts();
  }, [API_URL]);

  const showParametroModalFunction = async (info) => {
    const time = new Date().getTime();
    setTimestamp((prev) => time);
    setSelectedTrabajo(info);
    setShowParametroModal(true);
  };

  const showImageModal = async (info) => {
    const time = new Date().getTime();
    setTimestamp((prev) => time);
    setSelectedTrabajo(info);
    setShowModal2(true);
  };

  const formatNivelTension = (value) => {
    if (!value) return "-";
    switch (value.toLowerCase()) {
      case "baja":
        return "Baja Tensión (BT)";
      case "media":
        return "Media Tensión (MT)";
      case "alta":
        return "Alta Tensión (AT)";
      default:
        return value;
    }
  };

  const showAsignacionModalFunction = async (info) => {
    setSelectedTrabajo(info);
    setShowAsignacionModal(true);
  };

  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const opcionesEstadisticas = [
    { value: null, name: "Todos" },
    { value: "LEVANTAMIENTO", name: "Levantamiento" },
    { value: "ENTREGABLE", name: "Implementación" },
    { value: "MANTENIMIENTO", name: "Mantenimiento" },
  ];

  const editarCentroDeTrabajo = async (id) => {
    navigate(`/proyectos/editar/${id}?editWorkCenter=true`);
  };

  const descargarReporte = async (filename, blob) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.pdf`;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const descargarExcelYReporte = async (filename, blob) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const columns = [
    {
      id: "cc_asignados",
      header: "Asignaciones",
      size: 100,
      enableColumnActions: false,
      enableColumnFilter: false,
      enableSorting: false,
      enableHiding: false,
      muiTableHeadCellProps: { sx: headCellCenterAlign },
      muiTableBodyCellProps: { sx: bodyCellCenterAlign },
      Cell: ({ row }) => {
        const isThisRowAsignaciones =
          row.getIsExpanded() && detailMode === "asignaciones";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              justifyContent: "center",
            }}
          >
            <IconButton
              size="small"
              onClick={() => toggleRowWithMode(row, "asignaciones")}
              title="Ver asignaciones"
            >
              {isThisRowAsignaciones ? (
                <ArrowDropUpIcon color="success" />
              ) : (
                <ArrowDropDownIcon color="success" />
              )}
            </IconButton>
          </div>
        );
      },
    },
    {
      id: "permisionario",
      accessorKey: "permisionario.razonSocial",
      header: "Permisionario",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      size: 160,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formateado = formatEmpresa(texto);
        const filter = table?.getState().globalFilter;
        return highlightText(formateado, filter);
      },
    },
    {
      id: "cliente",
      accessorKey: "cliente.razonSocial",
      header: "Usuario final",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      size: 150,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formatted = formatEmpresa(texto);
        const filter = table?.getState().globalFilter;
        return highlightText(formatted, filter);
      },
    },
    {
      id: "proyecto",
      accessorKey: "proyecto.nombre",
      header: "Proyecto",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      size: 130,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const capitalized = texto
          .toLowerCase()
          .replace(/(?:^|\s|\.|-|\/)\S/g, (char) => char.toUpperCase());
        const filter = table?.getState().globalFilter;
        return highlightText(capitalized, filter);
      },
    },
    {
      id: "nombre",
      accessorKey: "nombre",
      header: "Centro de carga",
      size: 140,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        title: "Centro de carga",
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formateado = formatEmpresa(texto);
        const search = table?.getState().globalFilter;
        return <>{highlightText(formateado, search)}</>;
      },
    },
    {
      id: "rpu",
      accessorKey: "rpu",
      header: "RPU",
      size: 140,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        title: "RPU",
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formateado = formatEmpresa(texto);
        const search = table?.getState().globalFilter;
        return <>{highlightText(formateado, search)}</>;
      },
    },
    {
      id: "nivelTension",
      accessorKey: "nivelTension",
      header: "Nivel de Tensión",
      filterFn: customStrainFilter,
      meta: { filterVariant: "strain" },
      width: 70,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row }) => (
        <div style={{ textAlign: "center" }}>
          {row.original.nivelTension
            ? formatNivelTension(row.original.nivelTension)
            : "-"}
        </div>
      ),
    },
    {
      id: "demandaContratada",
      accessorKey: "",
      header: "Demanda Contratada (kW)",
      filterFn: customNumberFilter,
      meta: { filterVariant: "numerico" },
      width: 70,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => (
        <div style={{ textAlign: "center" }}>
          {row.original.demandaContratada
            ? row.original.demandaContratada
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "-"}
        </div>
      ),
    },
    {
      id: "tipoTrabajo",
      accessorKey: "tipoTrabajo.nombre",
      header: "Estructura de desgloce de trabajo",
      Header: () => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            Estructura de desgloce
          </Box>
          <Box component="span">de trabajo</Box>
        </Box>
      ),
      size: 170,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        title: "Estructura de desgloce de trabajo",
        sx: headCellLeftAlign,
        minWidth: 0,
        overflow: "hidden",
        "& .Mui-TableHeadCell-Content, & .Mui-TableHeadCell-Content-Labels": {
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const capitalized = texto
          .toLowerCase()
          .replace(/(?:^|\s|\.|-|\/)\S/g, (char) => char.toUpperCase());
        const filter = table?.getState().globalFilter;
        return highlightText(capitalized, filter);
      },
    },
    {
      id: "progresoImagenes",
      accessorKey: "progreso.progresoImagenes",
      header: "% fotos",
      filterFn: customNumberFilter,
      meta: { filterVariant: "numerico" },
      size: 100,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ cell }) => {
        const value = cell.getValue();
        const number = Math.ceil(value);
        const displayValue = !isNaN(number) ? `${number}%` : "0%";

        return (
          <div
            className="progress-bar-container"
            style={{
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => showImageModal(cell.row.original)}
          >
            <CircularProgressbar
              value={number}
              text={displayValue}
              styles={buildStyles({
                pathColor: "#223D51",
                textColor: "#000",
                trailColor: "#d6d6d6",
              })}
            />
          </div>
        );
      },
    },
    {
      id: "progresoParametros",
      accessorKey: "progreso.progresoParametros",
      header: "% Parámetros",
      filterFn: customNumberFilter,
      meta: { filterVariant: "numerico" },
      size: 130,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ cell }) => {
        const value = cell.getValue();
        const number = Math.ceil(value);
        const displayValue = !isNaN(number) ? `${number}%` : "0%";

        return (
          <div
            className="progress-bar-container"
            style={{
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => showParametroModalFunction(cell.row.original)}
          >
            <CircularProgressbar
              value={number}
              text={displayValue}
              styles={buildStyles({
                pathColor: "#223D51",
                textColor: "#000",
                trailColor: "#d6d6d6",
              })}
            />
          </div>
        );
      },
    },
    {
      id: "asignar",
      header: "Asignar",
      size: 130,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ cell }) => {
        return (
          <Button
            variant="outlined"
            size="small"
            onClick={() => showAsignacionModalFunction(cell.row.original)}
            sx={{
              color: "#223D51",
              borderColor: "#223D51",
              textTransform: "none",
              fontWeight: "700",
            }}
          >
            Asignar
          </Button>
        );
      },
    },
    {
      id: "usuarioNombre",
      header: (
        <div
          title="Usuario que creó el punto de carga"
          style={{
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            width: "100%",
          }}
        >
          <span
            style={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            Nombre
          </span>
          <span
            style={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            usuario
          </span>
        </div>
      ),
      size: 90,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
        minWidth: 0,
        overflow: "hidden",
        "& .Mui-TableHeadCell-Content, & .Mui-TableHeadCell-Content-Labels": {
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      },
      Cell: (params) => {
        const value = params.row.original?.usuario?.nombre || null;
        const capitalized = value
          ? value
              ?.toLowerCase()
              .replace(/(?:^|\s|\.|-|\/)\S/g, (char) => char?.toUpperCase())
          : "-";
        return (
          <span title="Usuario que creó el punto de carga">{capitalized}</span>
        );
      },
    },
    {
      id: "submenu",
      header: " ",
      size: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => {
        const rowData = row.original;
        const anchorRef = useRef(null);
        const isOpen = openMenuIndex === row.index;

        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={anchorRef}
              onClick={() => toggleMenuOptions(row.index)}
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <Popper
              open={isOpen}
              anchorEl={anchorRef.current}
              placement="bottom-start"
              style={{ zIndex: 9999 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    marginTop: "5px",
                    padding: "5px",
                    minWidth: "150px",
                  }}
                >
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => editarCentroDeTrabajo(row.original.id)}
                  >
                    <img
                      src={Editar}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Editar centro de carga
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const renderDetailPanel = useCallback(
    ({ row }) => {
      if (detailMode === "asignaciones") {
        const items = row.original.trabajosAsignados ?? [];

        const asignacionesLevantamiento = items.filter(
          (item) => item.faseTrabajo.name === "LEVANTAMIENTO"
        );

        const asignacionesEntregable = items.filter(
          (item) => item.faseTrabajo.name === "ENTREGABLE"
        );

        const asignacionesMantenimiento = items.filter(
          (item) => item.faseTrabajo.name === "MANTENIMIENTO"
        );

        return (
          <div
            style={{
              background: "#f9f9f9",
              width: "86vw",
              padding: 20,
              borderRadius: 12,
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}
            >
              <h2 style={{ margin: 0 }}>
                Asignaciones: {formatEmpresa(row.original?.nombre) || ""}
              </h2>

              <div style={{ display: "flex", gap: "12px" }}>
                <IconButton
                  title="Copiar enlace de descarga"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(
                      `${API_URL}/proyectos/descargar-reporte/${row.original.id}`
                    );
                  }}
                >
                  <Link />
                </IconButton>
                <CustomButton
                  color={"#FFFFFF"}
                  background={"#223D51"}
                  text="Reporte general"
                  width="180px"
                  height="36px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px solid #D9D9D9"
                  onClick={async () => {
                    try {
                      setShowLoader(true);
                      const blob = await abrirReporte(API_URL, row.original.id);
                      setShowLoader(false);
                      descargarReporte(
                        `Reporte General ${row.original.id}`,
                        blob
                      );
                    } catch (error) {
                      setShowLoader(false);
                      setShowSnackbar(true);
                      setSnackbarMessage(
                        "Ocurrió un error al generar el reporte."
                      );
                    }
                  }}
                  type="button"
                  src={DescargarG}
                  icon={true}
                  iconW="16px"
                  iconH="16px"
                  iconM="8px"
                />
              </div>
            </div>

            {(() => {
              const { hasLev, hasImp, hasMant } = detectTipos(items);
              const id = row.original.id;
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <Accordion disabled={!hasLev}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{ flexDirection: "row-reverse" }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "190px 120px 40px",
                          columnGap: "10px",
                        }}
                      >
                        <h2
                          style={{
                            margin: "0 0 0 8px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          Levantamientos{" "}
                          <span>({asignacionesLevantamiento.length})</span>
                        </h2>
                        <Box
                          onClick={async (e) => {
                            e.stopPropagation();
                            try {
                              setShowLoader(true);
                              const blob = await abrirReporte(
                                API_URL,
                                id,
                                "LEVANTAMIENTO"
                              );
                              setShowLoader(false);
                              descargarReporte(
                                `Reporte de Levantamiento ${id}`,
                                blob
                              );
                            } catch (error) {
                              setShowLoader(false);
                              setShowSnackbar(true);
                              setSnackbarMessage(
                                "Ocurrió un error al generar el reporte."
                              );
                            }
                          }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            px: 2,
                            py: "4px",
                            border: "1px solid #223D51",
                            borderRadius: "4px",
                            color: "#223D51",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            fontWeight: 700,
                            cursor: "pointer",
                            userSelect: "none",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: "rgba(34, 61, 81, 0.1)",
                            },
                          }}
                        >
                          <img
                            style={{ marginRight: 0 }}
                            src={DescargarG2}
                            alt=""
                          />
                          Descargar
                        </Box>
                        <IconButton
                          title="Copiar enlace de descarga"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(
                              `${API_URL}/proyectos/descargar-reporte/${id}?fase=LEVANTAMIENTO`
                            );
                          }}
                        >
                          <Link />
                        </IconButton>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {hasLev ? (
                        <TablaAsignaciones
                          asignaciones={asignacionesLevantamiento}
                          user={user}
                          API_URL={API_URL}
                          trabajo={row.original}
                          fase="LEVANTAMIENTO"
                        />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion disabled={!hasImp}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{ flexDirection: "row-reverse" }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "190px 120px 40px",
                          columnGap: "10px",
                        }}
                      >
                        <h2
                          style={{
                            margin: "0 0 0 8px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          Implementaciones{" "}
                          <span>({asignacionesEntregable.length})</span>
                        </h2>

                        <Box
                          onClick={async (e) => {
                            e.stopPropagation();
                            try {
                              setShowLoader(true);
                              const blob = await abrirReporte(
                                API_URL,
                                id,
                                "ENTREGABLE"
                              );
                              descargarReporte(
                                `Reporte de Implementación ${id}`,
                                blob
                              );
                            } catch (error) {
                              setShowLoader(false);
                              setShowSnackbar(true);
                              setSnackbarMessage(
                                "Ocurrió un error al generar el reporte."
                              );
                            }
                          }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            px: 2,
                            py: "4px",
                            border: "1px solid #223D51",
                            borderRadius: "4px",
                            color: "#223D51",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            fontWeight: 700,
                            cursor: "pointer",
                            userSelect: "none",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: "rgba(34, 61, 81, 0.1)",
                            },
                          }}
                        >
                          <img
                            style={{ marginRight: 0 }}
                            src={DescargarG2}
                            alt=""
                          />
                          Descargar
                        </Box>
                        <IconButton
                          title="Copiar enlace de descarga"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(
                              `${API_URL}/proyectos/descargar-reporte/${id}?fase=ENTREGABLE`
                            );
                          }}
                        >
                          <Link />
                        </IconButton>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {hasImp ? (
                        <TablaAsignaciones
                          asignaciones={asignacionesEntregable}
                          user={user}
                          API_URL={API_URL}
                          trabajo={row.original}
                          fase="ENTREGABLE"
                        />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion disabled={!hasMant}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{ flexDirection: "row-reverse" }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "190px 120px 40px",
                          columnGap: "10px",
                        }}
                      >
                        <h2
                          style={{
                            margin: "0 0 0 8px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          Mantenimientos{" "}
                          <span>({asignacionesMantenimiento.length})</span>
                        </h2>

                        <Box
                          onClick={async (e) => {
                            e.stopPropagation();

                            try {
                              setShowLoader(true);
                              const blob = await abrirReporte(
                                API_URL,
                                id,
                                "MANTENIMIENTO"
                              );
                              descargarReporte(
                                `Reporte de Mantenimiento ${id}`,
                                blob
                              );
                            } catch (error) {
                              setShowLoader(false);
                              setShowSnackbar(true);
                              setSnackbarMessage(
                                "Ocurrió un error al generar el reporte."
                              );
                            }
                          }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            px: 2,
                            py: "4px",
                            border: "1px solid #223D51",
                            borderRadius: "4px",
                            color: "#223D51",
                            fontSize: "0.875rem",
                            textTransform: "none",
                            fontWeight: 700,
                            cursor: "pointer",
                            userSelect: "none",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: "rgba(34, 61, 81, 0.1)",
                            },
                          }}
                        >
                          <img
                            style={{ marginRight: 0 }}
                            src={DescargarG2}
                            alt=""
                          />
                          Descargar
                        </Box>
                        <IconButton
                          title="Copiar enlace de descarga"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(
                              `${API_URL}/proyectos/descargar-reporte/${id}?fase=MANTENIMIENTO`
                            );
                          }}
                        >
                          <Link />
                        </IconButton>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {hasMant ? (
                        <TablaAsignaciones
                          asignaciones={asignacionesMantenimiento}
                          user={user}
                          API_URL={API_URL}
                          trabajo={row.original}
                          fase="MANTENIMIENTO"
                        />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>
                </div>
              );
            })()}
          </div>
        );
      }

      return (
        <div
          style={{
            background: "#f9f9f9",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "86vw",
            padding: 20,
            gap: 20,
          }}
        >
          <h2 style={{ margin: 0 }}>
            Tracking: {formatEmpresa(row.original.nombre) || ""}
          </h2>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "600px",
              background: "#fff",
              padding: "10px 30px",
              borderRadius: 12,
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              alignItems: "center",
            }}
          >
            <h2 style={{ margin: 0 }}>Etapa</h2>
            <h2 style={{ margin: 0 }}>Detalles</h2>
            <h2 style={{ margin: 0 }}>Acciones</h2>
          </div>
          <TrackerProjectsStepper
            API_URL={API_URL}
            events={events}
            user={user}
            id_trabajo={row.original.id}
            setEvents={setEvents}
            nombre={row.original.nombre}
            pm={row.original?.proyecto?.usuarioPM}
          />
        </div>
      );
    },
    [detailMode, events, tableInstance]
  );

  const options = useMemo(
    () => ({
      enableRowSelection: true,
      enableSelectAll: true,
      positionToolbarAlertBanner: "none",
      enableColumnFilters: false,
      enableSorting: true,
      enablePagination: true,
      manualPagination: true,
      rowCount: rowCount,
      onPaginationChange: setPagination,
      state: {
        pagination,
      },
      initialState: {
        columnOrder: [
          "mrt-row-select",
          "mrt-row-expand",
          "cc_asignados",
          "permisionario",
          "cliente",
          "proyecto",
          "nombre",
          "rpu",
          "nivelTension",
          "demandaContratada",
          "tipoTrabajo",
          "progresoImagenes",
          "progresoParametros",
          "asignar",
          "usuarioNombre",
          "submenu",
        ],
      },
      localization: {
        ...MRT_Localization_ES,
        expand: "Tracker",
      },
      enableExpandAll: false,
      muiExpandButtonProps: ({ row }) => {
        const isTrackerOpen = row.getIsExpanded() && detailMode === "tracker";
        return {
          title: "Ver tracker",
          children: isTrackerOpen ? (
            <ArrowDropUpIcon color="success" />
          ) : (
            <ArrowDropDownIcon color="success" />
          ),
          onClick: () => toggleRowWithMode(row, "tracker"),
        };
      },
      renderDetailPanel,
    }),
    [renderDetailPanel, detailMode, tableInstance, pagination, rowCount] // Update dependencies
  );

  const getCacheKey = (pageIndex, pageSize, criterios) => {
    const criteriosHash = JSON.stringify(criterios);
    return `${pageIndex}-${pageSize}-${criteriosHash}`;
  };

  useEffect(() => {
    pageCache.current.clear();
  }, [criterios]);

  useEffect(() => {
    const fetchData = async () => {
      const cacheKey = getCacheKey(
        pagination.pageIndex,
        pagination.pageSize,
        criterios
      );

      const cachedData = pageCache.current.get(cacheKey);
      if (cachedData) {
        setData(cachedData.data);
        setFilteredBase(cachedData.data);
        setRowCount(cachedData.total);
        if (cachedData.baseCounts) {
          setBaseCounts(cachedData.baseCounts);
        }
        return;
      }

      setShowLoader(true);
      try {
        const limit = pagination.pageSize;
        const offset = pagination.pageIndex * pagination.pageSize;

        // Always fetch base counts (without faseTrabajoFilter) in parallel
        const baseFilters = { ...criterios, faseTrabajoFilter: null };

        const [trackerData, response, baseResponse] = await Promise.all([
          getTrackerProyectos(API_URL),
          fetchTrabajosConAsignados(API_URL, criterios, limit, offset),
          // Only fetch base counts if we have a fase filter active
          criterios.faseTrabajoFilter
            ? fetchTrabajosConAsignados(API_URL, baseFilters, 1, 0)
            : Promise.resolve(null),
        ]);

        const {
          trabajosConAsignados,
          total,
          totalWithAssignments,
          byCategory,
        } = response;

        setRowCount(total);

        const serverCounts = {
          totalWithAssignments: totalWithAssignments || 0,
          byCategory: byCategory || {
            LEVANTAMIENTO: 0,
            ENTREGABLE: 0,
            MANTENIMIENTO: 0,
          },
        };

        // Update base counts
        let newBaseCounts;
        if (criterios.faseTrabajoFilter && baseResponse) {
          // Use the separate base request when filtering by fase
          newBaseCounts = {
            total: baseResponse.total || 0,
            totalWithAssignments: baseResponse.totalWithAssignments || 0,
            byCategory: baseResponse.byCategory || {
              LEVANTAMIENTO: 0,
              ENTREGABLE: 0,
              MANTENIMIENTO: 0,
            },
          };
        } else {
          // Use current response when not filtering by fase
          newBaseCounts = {
            total: total,
            ...serverCounts,
          };
        }
        setBaseCounts(newBaseCounts);

        const newData = trabajosConAsignados.map((t) => {
          const trackerForJob = trackerData.find(
            (tr) => tr.id_trabajo === t.id
          );
          return trackerForJob
            ? { ...t, etapa: trackerForJob.etapa, tracker: trackerForJob }
            : {
                ...t,
                etapa: 2,
                tracker: {
                  id: 0,
                  id_usuario: user.id,
                  id_trabajo: t.id,
                  etapa: 2,
                  fecha_actualizacion: new Date().toISOString(),
                  estatus: "pendiente",
                  tipo: "proyecto",
                },
              };
        });

        pageCache.current.set(cacheKey, {
          data: newData,
          total: total,
          countWithAsignados: serverCounts,
          baseCounts: newBaseCounts,
        });

        setData(newData);
        setFilteredBase(newData);
      } finally {
        setShowLoader(false);
      }
    };
    fetchData();
  }, [API_URL, criterios, user.id, pagination.pageIndex, pagination.pageSize]);

  return (
    <div className="pgp-container" style={{ display: "flex", width: "100%" }}>
      <LoaderDialog open={showLoader} />
      <div className="pgp-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProjects} />
      </div>
      <ModalExcelAsignaciones
        API_URL={API_URL}
        onClose={() => setShowModalExcel(false)}
        open={showModalExcel}
        onConfirm={handleConfirmExcel}
        companies={companies}
      />
      <ModalSubirExcelTrabajos
        API_URL={API_URL}
        onClose={() => setShowModalSubirArchivo(false)}
        open={showModalSubirArchivo}
        onConfirm={() => setShowModalSubirArchivo(false)}
        setShowLoader={setShowLoader}
      />

      <ModalSubirExcelAsignaciones
        API_URL={API_URL}
        onClose={() => setShowModalSubirArchivoAsignaciones(false)}
        open={showModalSubirArchivoAsignaciones}
        onConfirm={() => setShowModalSubirArchivoAsignaciones(false)}
        setShowLoader={setShowLoader}
      />

      <ImagenesModal
        API_URL={API_URL}
        handleCloseModal={() => setShowModal2(false)}
        showModal={showModal2}
        trabajoId={selectedTrabajo?.id}
        trabajoName={selectedTrabajo?.nombre}
        trabajo={selectedTrabajo}
        timestamp={timestamp}
        user={user}
      />
      <ParametrosModal
        showModal={showParametroModal}
        API_URL={API_URL}
        handleCloseModal={() => setShowParametroModal(false)}
        trabajoId={selectedTrabajo?.id}
        trabajoName={selectedTrabajo?.nombre}
        trabajo={selectedTrabajo}
        timestamp={timestamp}
      />
      <ModalNuevaAsignacion
        API_URL={API_URL}
        handleCloseModal={() => setShowAsignacionModal(false)}
        showModal={showAsignacionModal}
        trabajo={selectedTrabajo}
        user={user}
        companies={companies}
        onConfirm={async () => {
          setShowAsignacionModal(false);
          setShowLoader(true);

          pageCache.current.clear();

          try {
            const limit = pagination.pageSize;
            const offset = pagination.pageIndex * pagination.pageSize;
            const [trackerData, response] = await Promise.all([
              getTrackerProyectos(API_URL),
              fetchTrabajosConAsignados(API_URL, criterios, limit, offset),
            ]);

            const { data: trabajosConAsignados, total } = response;
            setRowCount(total);

            const newData = trabajosConAsignados.map((t) => {
              const trackerForJob = trackerData.find(
                (tr) => tr.id_trabajo === t.id
              );
              return trackerForJob
                ? { ...t, etapa: trackerForJob.etapa, tracker: trackerForJob }
                : {
                    ...t,
                    etapa: 2,
                    tracker: {
                      id: 0,
                      id_usuario: user.id,
                      id_trabajo: t.id,
                      etapa: 2,
                      fecha_actualizacion: new Date().toISOString(),
                      estatus: "pendiente",
                      tipo: "proyecto",
                    },
                  };
            });

            setData(newData);
            setFilteredBase(newData);
          } finally {
            setShowLoader(false);
          }
        }}
      />
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <div
        className="pgp-content"
        style={{ flex: 1, minWidth: 0, padding: "10px" }}
      >
        <div
          className="pgp-cards"
          style={{ display: "flex", gap: "20px", marginBottom: "16px" }}
        >
          {opcionesEstadisticas.map((opcion) => (
            <Card
              key={opcion.value ?? "todos"}
              status={opcion.name}
              count={
                opcion.value === null
                  ? baseCounts.total
                  : baseCounts.byCategory?.[opcion.value] || 0
              }
              progress={
                opcion.value === null
                  ? undefined
                  : baseCounts.total > 0
                  ? Math.round(
                      ((baseCounts.byCategory?.[opcion.value] || 0) /
                        baseCounts.total) *
                        100
                    )
                  : 0
              }
              color={"#223D51"}
              onClick={() => {
                if (tableInstance) {
                  tableInstance.resetExpanded();
                  setSelectedProject(null);
                }

                // Reset pagination when changing filter
                setPagination({ pageIndex: 0, pageSize: pagination.pageSize });

                // Update criterios with the category filter
                setCriterios((prev) => ({
                  ...prev,
                  faseTrabajoFilter: opcion.value,
                }));

                setStatusFilter(opcion.value);
              }}
              style={{
                boxShadow:
                  statusFilter === opcion.value
                    ? "0 5px 15px rgba(0, 0, 0, 0.35)"
                    : "none",
              }}
            />
          ))}
        </div>

        <TrackerStepperProjects
          width={width}
          selectedProject={selectedProject}
          selectedEtapa={selectedEtapa}
          handleEtapaFilter={handleEtapaFilter}
        />

        <div
          className="pgp-controls"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <h2 style={{ margin: 0 }}>Centros de Carga</h2>
          <Button
            onClick={handleClick}
            className="custom-button-menu-cc"
            endIcon={<KeyboardArrowDownIcon />}
          >
            Subir y Descargar
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              list: {
                "aria-labelledby": "basic-button",
              },
            }}
          >
            <MenuItem
              className="menu-item-text"
              onClick={() => {
                setShowModalSubirArchivo(true);
                handleClose();
              }}
            >
              <img
                src={SubirG}
                alt=""
                style={{ width: "16px", height: "16px", marginRight: "8px" }}
              />
              Subir Excel Trabajos
            </MenuItem>
            <MenuItem
              className="menu-item-text"
              onClick={() => {
                setShowModalSubirArchivoAsignaciones(true);
                handleClose();
              }}
            >
              <img
                src={SubirG}
                alt=""
                style={{ width: "16px", height: "16px", marginRight: "8px" }}
              />
              Asignar trabajos con excel
            </MenuItem>
            <MenuItem
              className="menu-item-text"
              onClick={async () => {
                const rows = getSelectedRows();

                if (rows.length > 0) {
                  try {
                    setShowLoader(true);
                    rows.forEach((row) => {
                      delete row.tracker;
                      delete row.trabajosAsignados;
                      delete row.etapa;
                      row.seleccion = true;
                    });
                    const blob = await descargarPDFTrabajos(API_URL, {
                      trabajos: rows,
                    });
                    setShowLoader(false);
                    descargarExcelYReporte(
                      "Archivo CRC-2 Autoabasto.pdf",
                      blob
                    );
                  } catch (error) {
                    setShowLoader(false);
                    setShowSnackbar(true);
                    setSnackbarMessage(
                      "Ocurrió un error al descargar los reportes"
                    );
                  }
                } else {
                  setShowSnackbar(true);
                  setSnackbarMessage(
                    "Debes seleccionar al menos un centro de carga"
                  );
                }
                handleClose();
              }}
            >
              <img
                src={DescargarG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              CRC-2 Autoabasto
            </MenuItem>
            <MenuItem
              className="menu-item-text"
              onClick={async () => {
                const rows = getSelectedRows();

                if (rows.length > 0) {
                  try {
                    setShowLoader(true);
                    rows.forEach((row) => {
                      delete row.tracker;
                      delete row.trabajosAsignados;
                      delete row.etapa;
                      row.seleccion = true;
                    });
                    const blob = await descargarExcelTrabajos(API_URL, {
                      trabajos: rows,
                    });
                    setShowLoader(false);
                    descargarExcelYReporte("excel-trabajos.xls", blob);
                  } catch (error) {
                    setShowLoader(false);
                    setShowSnackbar(true);
                    setSnackbarMessage(
                      "Ocurrió un error al descargar los reportes"
                    );
                  }
                } else {
                  setShowSnackbar(true);
                  setSnackbarMessage(
                    "Debes seleccionar al menos un centro de carga"
                  );
                }
                handleClose();
              }}
            >
              <img
                src={DescargarG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              Excel Trabajos
            </MenuItem>
            <MenuItem
              className="menu-item-text"
              onClick={async () => {
                const rows = getSelectedRows();

                if (rows.length > 0) {
                  try {
                    setShowLoader(true);
                    rows.forEach((row) => {
                      delete row.tracker;
                      delete row.trabajosAsignados;
                      delete row.etapa;
                      row.seleccion = true;
                    });
                    const blob = await descargarExcelTrabajosYParametros(
                      API_URL,
                      {
                        trabajos: rows,
                      }
                    );
                    setShowLoader(false);
                    descargarExcelYReporte(
                      "excel-trabajos-parametros.xls",
                      blob
                    );
                  } catch (error) {
                    setShowLoader(false);
                    setShowSnackbar(true);
                    setSnackbarMessage(
                      "Ocurrió un error al descargar los reportes"
                    );
                  }
                } else {
                  setShowSnackbar(true);
                  setSnackbarMessage(
                    "Debes seleccionar al menos un centro de carga"
                  );
                }
                handleClose();
              }}
            >
              <img
                src={DescargarG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              Excel trabajos y parámetros
            </MenuItem>
            <MenuItem
              className="menu-item-text"
              onClick={() => {
                const rows = getSelectedRows();
                if (rows.length > 0) {
                  setShowModalExcel(true);
                } else {
                  setShowSnackbar(true);
                  setSnackbarMessage(
                    "Debes seleccionar al menos un centro de carga"
                  );
                }
                handleClose();
              }}
            >
              <img
                src={DescargarG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              Excel Asignaciones
            </MenuItem>
            <MenuItem
              className="menu-item-text"
              onClick={async () => {
                const rows = getSelectedRows();

                if (rows.length > 0) {
                  try {
                    setShowLoader(true);
                    rows.forEach((row) => {
                      delete row.tracker;
                      delete row.trabajosAsignados;
                      delete row.etapa;
                      row.seleccion = true;
                    });
                    const blob = await generarZipReportesTrabajos(API_URL, {
                      trabajos: rows,
                    });
                    setShowLoader(false);
                    descargarExcelYReporte("reportes-trabajos.zip", blob);
                  } catch (error) {
                    setShowLoader(false);
                    setShowSnackbar(true);
                    setSnackbarMessage(
                      "Ocurrió un error al descargar los reportes"
                    );
                  }
                } else {
                  setShowSnackbar(true);
                  setSnackbarMessage(
                    "Debes seleccionar al menos un centro de carga"
                  );
                }
                handleClose();
              }}
            >
              <img
                src={DescargarG}
                alt=""
                style={{ width: "16px", marginRight: "8px" }}
              />
              Descargar Reportes
            </MenuItem>
          </Menu>
          <CustomButton
            background={"#FFFFFF"}
            width={"160px"}
            height={"31px"}
            fontSize={"14px"}
            color={"#223D51"}
            text={"Filtros Avanzados"}
            fontWeight={700}
            fontStyle={"normal"}
            border={"0.5px solid #C3C3C3"}
            icon={true}
            src={Buscar}
            iconW={"12px"}
            iconM={"5px"}
            onClick={handleOpenModal}
          />
          <FilterChips
            criterios={criterios}
            onChange={setCriterios}
            projects={projects}
            permisionarios={permisionarios}
            states={states}
            clients={clients}
            companies={companies}
          />
          <ProjectFilterModal
            states={states.length > 0 ? states : []}
            companies={companies.length > 0 ? companies : []}
            projects={projects.length > 0 ? projects : []}
            clients={clients.length > 0 ? clients : []}
            permisionarios={permisionarios.length > 0 ? permisionarios : []}
            handleCloseModal={handleCloseModal}
            showModal={showModal}
            criterios={criterios}
            setCriterios={setCriterios}
            statusOptions={statusOptions}
          />
        </div>
        <div className="pgp-tableWrap" style={{ width: "100%", minWidth: 0 }}>
          <TablaMRT
            onTableReady={(table) => setTableInstance(table)}
            columns={columns}
            data={sortedData}
            options={options}
          />
        </div>
      </div>
    </div>
  );
};
export default ProjectsPage;
